import { render } from "./newDistpatchForm.vue?vue&type=template&id=3f9072dc&scoped=true"
import script from "./newDistpatchForm.vue?vue&type=script&lang=js"
export * from "./newDistpatchForm.vue?vue&type=script&lang=js"

import "./newDistpatchForm.vue?vue&type=style&index=0&id=3f9072dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9072dc"]])

export default __exports__